module.exports = __webpack_public_path__ + "img/overview-map.38842f41.svg";